import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NotificationCenterComponent } from './notification-center.component';
import { NotificationBellComponent } from './notification-bell/notification-bell.component';
import { NotificationCenterService } from './notification-center.service';
import { BugReportModule } from '../bug-report/bug-report.module';

const routes: Routes = [
  { path: '', component: NotificationCenterComponent }
];

@NgModule({
  declarations: [
    NotificationCenterComponent,
    NotificationBellComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule.forChild(routes),
    TranslateModule,
    BugReportModule
  ],
  providers: [NotificationCenterService],
  exports: [NotificationBellComponent] // Export for use in navbar/header
})
export class NotificationCenterModule { }
